import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {addClass, removeClass} from '../utils/ClassName';
import {getURLParamByName} from '../utils/utils';

function useHideNavParam() {
	const {search} = useLocation();
	const nbaHeader = document.getElementById('nba-nav');
	const nbaFooter = document.getElementById('nba-footer');
	const hiddenClass = 'hidden-with-important';

	useEffect(() => {
		const hideNav = getURLParamByName('hidenav', search);
		if (hideNav === 'true') {
			addClass(nbaHeader, hiddenClass);
			addClass(nbaFooter, hiddenClass);
		} else {
			removeClass(nbaHeader, hiddenClass);
			removeClass(nbaFooter, hiddenClass);
		}
	}, [search, nbaHeader, nbaFooter]);
}

export default useHideNavParam;
